module.exports = __webpack_public_path__ + "static/img/title_cgzp.6a5cef59.png";